import { AppBar, Box, Drawer, IconButton, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import { useFlag } from "../utils";
import { MenuIcon } from "../icons";
import { LayoutProvider } from "../layout";
import { VCAppLogo } from "../logo/VCAppLogo";
export function AppShell(props) {
    const { children, appName, sideNav, sideNavWidth = 200, topNav, sideNavFixed = "md", footer, } = props;
    const [drawerOpen, setDrawerOpen, clearDrawerOpen, toggleDrawerOpen] = useFlag(false);
    const theme = useTheme();
    const drawerPermanent = useMediaQuery(theme.breakpoints.up(sideNavFixed));
    useEffect(() => {
        if (drawerPermanent) {
            setDrawerOpen();
        }
    }, [drawerPermanent]);
    return (React.createElement(LayoutProvider, { appName: appName },
        React.createElement(Box, { sx: {
                display: "flex",
                flexFlow: "column nowrap",
                "@media screen": {
                    height: "100vh",
                    overflowY: "scroll"
                },
                "@media print": {
                    padding: 0,
                    margin: 0
                }
            } },
            React.createElement(AppBar, { elevation: 0, position: "static", color: "inherit", sx: {
                    borderBottom: 1,
                    borderColor: "divider",
                    backgroundColor: "paper.elevation1",
                    color: "text.primary",
                    displayPrint: "none"
                } },
                React.createElement(Box, { sx: {
                        position: "relative",
                        display: "flex",
                        flexFlow: "row nowrap",
                        justifyContent: "space-between",
                        alignItems: "center",
                        px: 2
                    } },
                    !drawerPermanent && (React.createElement(IconButton, { edge: "start", sx: { marginRight: 1 }, color: "inherit", "aria-label": "menu", onClick: toggleDrawerOpen, disabled: !sideNav, size: "large" },
                        React.createElement(MenuIcon, null))),
                    React.createElement(VCAppLogo, { appName: drawerPermanent ? appName : undefined, sx: Object.assign({ py: 1 }, (!drawerPermanent && {
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)"
                        })) }),
                    topNav,
                    !topNav && React.createElement(Box, null))),
            React.createElement(Box, { sx: {
                    flex: "1 1 auto",
                    display: "flex",
                    flexFlow: "row nowrap",
                } },
                sideNav && (React.createElement(Drawer, { variant: !drawerPermanent ? "temporary" : "permanent", sx: {
                        displayPrint: "none",
                        [`& .MuiDrawer-paper`]: {
                            position: "relative",
                            whiteSpace: "nowrap",
                            overflowX: "hidden",
                            width: sideNavWidth,
                            boxSizing: "border-box"
                        },
                        ["& .MuiPaper-elevation0"]: {
                            backgroundColor: "paper.elevation1"
                        }
                    }, open: drawerOpen, onClick: !drawerPermanent ? clearDrawerOpen : undefined, onClose: clearDrawerOpen },
                    !drawerPermanent && (React.createElement(VCAppLogo, { appName: appName, sx: {
                            px: 2,
                            py: 1,
                        } })),
                    sideNav)),
                React.createElement(Box, { sx: {
                        py: 4,
                        flex: 1,
                        maxWidth: "100%",
                        "@media print": { padding: 0, margin: 0 }
                    } }, children)),
            footer && (React.createElement(Box, { sx: {
                    borderTop: 1,
                    borderColor: "divider",
                    backgroundColor: theme.palette.background.paper,
                    color: "text.primary",
                    displayPrint: "none"
                } }, footer)))));
}
//# sourceMappingURL=AppShell.js.map